/* unplugin-vue-components disabled */import { render } from "./exam-Listen.vue?vue&type=template&id=a1a877f8&scoped=true"
import script from "./exam-Listen.vue?vue&type=script&lang=js"
export * from "./exam-Listen.vue?vue&type=script&lang=js"

import "./exam-Listen.vue?vue&type=style&index=0&id=a1a877f8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a877f8"]])

export default __exports__